import gql from 'graphql-tag';

const qnaQuery = gql`
  query {
    IDS_UGC_QNA_ANSWER: translation(key: "IDS_UGC_QNA_ANSWER")
    IDS_UGC_QNA_SEARCH_RESULT_COUNT: translation(key: "IDS_UGC_QNA_SEARCH_RESULT_COUNT")
    IDS_UGC_QNA_CUSTOMER_SERVICE: translation(key: "IDS_UGC_QNA_CUSTOMER_SERVICE")
    IDS_UGC_QNA_BRAND: translation(key: "IDS_UGC_QNA_BRAND")
    IDS_UGC_QNA_BEST_ANSWER: translation(key: "IDS_UGC_QNA_BEST_ANSWER")
    IDS_COM_VENDOR_COMMENT_DISCLAIMER_TEXT: translation(key: "IDS_COM_VENDOR_COMMENT_DISCLAIMER_TEXT")
    IDS_UGC_QNA_VERIFIED_PURCHASE: translation(key: "IDS_UGC_QNA_VERIFIED_PURCHASE")
    IDS_UGC_QNA_REWARDED_ANSWER: translation(key: "IDS_UGC_QNA_REWARDED_ANSWER")
    IDS_UGC_QNA_REWARDED_ANSWER_READ_MORE: translation(key: "IDS_UGC_QNA_REWARDED_ANSWER_READ_MORE")
    IDS_UGC_QNA_OKEAY: translation(key: "IDS_UGC_QNA_OKEAY")
    IDS_UGC_INCENTIVE_SWITCH: translation(key: "IDS_UGC_INCENTIVE_SWITCH")
    IDS_BTN_REPORT_ABUSE: translation(key: "IDS_BTN_REPORT-ABUSE")
    IDS_TXT_FEEDBACK_HAS_BEEN_SUBMITTED: translation(key: "IDS_TXT_FEEDBACK_HAS_BEEN_SUBMITTED")
    IDS_UGC_QNA_LIST_EMPTY_NOTICE: translation(key: "IDS_UGC_QNA_LIST_EMPTY_NOTICE")
    IDS_UGC_QNA_SEE_ALL_QNA: translation(key: "IDS_UGC_QNA_SEE_ALL_QNA")
    IDS_LBL_SEARCH: translation(key: "IDS_LBL_SEARCH")
    IDS_UGC_QNA_ANSWER_MODAL_TITLE: translation(key: "IDS_UGC_QNA_ANSWER_MODAL_TITLE")
    IDS_UGC_QNA_ANSWER_PLACEHOLDER: translation(key: "IDS_UGC_QNA_ANSWER_PLACEHOLDER")
    IDS_UGC_QNA_ASK_QUESTION_MODAL_TITLE: translation(key: "IDS_UGC_QNA_ASK_QUESTION_MODAL_TITLE")
    IDS_UGC_BTN_ASK_QUESTION: translation(key: "IDS_UGC_BTN_ASK_QUESTION")
    IDS_LBL_SELECT_CATEGORY: translation(key: "IDS_LBL_SELECT-CATEGORY")
    IDS_UGC_QNA_WRITE_QUESTION: translation(key: "IDS_UGC_QNA_WRITE_QUESTION")
    IDS_UGC_QNA_MODAL_NOTICE: translation(key: "IDS_UGC_QNA_MODAL_NOTICE")
    IDS_UGC_QNA_SORT_FILTER_TITLE: translation(key: "IDS_UGC_QNA_SORT_FILTER_TITLE")
    IDS_UGC_QNA_SORT_BY: translation(key: "IDS_UGC_QNA_SORT_BY")
    IDS_UGC_CATEGORY: translation(key: "IDS_UGC_CATEGORY")
    IDS_UGC_QNA_MODAL_SUBMIT: translation(key: "IDS_UGC_QNA_MODAL_SUBMIT")
    IDS_UGC_QNA_MODAL_CANCEL: translation(key: "IDS_UGC_QNA_MODAL_CANCEL")
    IDS_UGC_QNA_MODAL_APPLY: translation(key: "IDS_UGC_QNA_MODAL_APPLY")
    IDS_UGC_QNA_TOAST_THANKS: translation(key: "IDS_UGC_QNA_TOAST_THANKS")
    IDS_UGC_QNA_TOAST_CHECK: translation(key: "IDS_UGC_QNA_TOAST_CHECK")
    IDS_UGC_QNA_ANSWER_MODAL_NOTICE: translation(key: "IDS_UGC_QNA_ANSWER_MODAL_NOTICE")
    IDS_QUESTION_SUBMITTED_SUCCESSFULLY: translation(key: "IDS_QUESTION_SUBMITTED_SUCCESSFULLY")
    IDS_UGC_SERVICE_DOWN: translation(key: "IDS_UGC_SERVICE_DOWN")
    IDS_UGC_UNEXPECTED_ERROR: translation(key: "IDS_UGC_UNEXPECTED_ERROR")
    IDS_UGC_NOT_FOUND: translation(key: "IDS_UGC_NOT_FOUND")
    IDS_NO_RESULTS_QUESTIONS: translation(key: "IDS_NO_RESULTS_QUESTIONS")
    IDS_UGC_QNA_TEXTAREA_LEAST_CHARACTERS: translation(key: "IDS_UGC_QNA_TEXTAREA_LEAST_CHARACTERS")
    IDS_UGC_QNA_TEXTAREA_MORE_CHARACTERS: translation(key: "IDS_UGC_QNA_TEXTAREA_MORE_CHARACTERS")
    IDS_UGC_ENTER_PLAIN_TEXT_MESSAGE: translation(key: "IDS_UGC_ENTER_PLAIN_TEXT_MESSAGE")
    IDS_UGC_PERIMETERX_IDENTITY_TITLE: translation(key: "IDS_UGC_PERIMETERX_IDENTITY_TITLE")
    IDS_UGC_REVIEWS_SHARE_TEXT: translation(key: "IDS_UGC_REVIEWS_SHARE_TEXT")
    IDS_UGC_QNA_MODULE_TITLE: translation(key: "IDS_UGC_QNA_MODULE_TITLE")
    IDS_UGC_QNA_LIST_VIEW_MORE_TEXT: translation(key: "IDS_UGC_QNA_LIST_VIEW_MORE_TEXT")
    IDS_UGC_QNA_SUBMIT_AN_ANSWER_TIPS: translation(key: "IDS_UGC_QNA_SUBMIT_AN_ANSWER_TIPS")
    IDS_UGC_QNA_SUBMIT_AN_ANSWER_TIPS_HONEST: translation(key: "IDS_UGC_QNA_SUBMIT_AN_ANSWER_TIPS_HONEST")
    IDS_UGC_QNA_SUBMIT_AN_ANSWER_TIPS_REWARD: translation(key: "IDS_UGC_QNA_SUBMIT_AN_ANSWER_TIPS_REWARD")
    IDS_UGC_ANSWERS_TO_THE_QUESTION: translation(key: "IDS_UGC_ANSWERS_TO_THE_QUESTION")
    IDS_MSG_SHOW_MORE: translation(key: "IDS_MSG_SHOW_MORE")
    IDS_MSG_SHOW_LESS: translation(key: "IDS_MSG_SHOW_LESS")
    IDS_UGC_REPORT_ABUSE_GUIDE: translation(key: "IDS_UGC_REPORT_ABUSE_GUIDE")
    IDS_UGC_REPORT_ABUSE_TOAST_SELECT_REASON: translation(key: "IDS_UGC_REPORT_ABUSE_TOAST_SELECT_REASON")
    IDS_UGC_REPORT_ABUSE_TOAST_ENTER_REASON: translation(key: "IDS_UGC_REPORT_ABUSE_TOAST_ENTER_REASON")
    IDS_UGC_REPORT_ABUSE_SUCCESS: translation(key: "IDS_UGC_REPORT_ABUSE_SUCCESS")
    IDS_UGC_REPORT_ABUSE_REPORTED: translation(key: "IDS_UGC_REPORT_ABUSE_REPORTED")
    IDS_UGC_REPORT_ABUSE_WRITE_REASON: translation(key: "IDS_UGC_REPORT_ABUSE_WRITE_REASON")
    IDS_MY_REVIEW_CANCEL_EDIT: translation(key: "IDS_MY_REVIEW_CANCEL_EDIT")
    IDS_BTN_EDIT_ANSWER: translation(key: "IDS_BTN_EDIT-ANSWER")
    IDS_LNK_CLOSE: translation(key: "IDS_LNK_CLOSE")
    IDS_UGC_ANSWERS_DISCLAIMER: translation(key: "IDS_UGC_ANSWERS_DISCLAIMER")
    IDS_UGC_HEALTH_CLAIM_DISCLAIMER: translation(key: "IDS_UGC_HEALTH_CLAIM_DISCLAIMER")
    IDS_GEN_DISCLAIMER: translation(key: "IDS_GEN_DISCLAIMER")
    IDS_FDA_DISCLAIMER: translation(key: "IDS_FDA_DISCLAIMER")
  }
`;

export default qnaQuery;
